import * as React from "react";
import { Route } from "react-router-dom";
import ProtectedRoute from "routes/protected";
import AdminDashboard from "page/admin/dashboard";
import { ConnectedOrdersList } from "page/admin/order/list";
import ThemesList from "page/admin/theme/list";
import UsersList from "page/user/list";
import EditUser from "page/user/edit";

const Admin = () => (
    <React.Fragment>
        <Route
            exact={true}
            key={"route-admin-dashboard"}
            path={"/admin"}
            component={AdminDashboard}
        />

        <ProtectedRoute
            key={"route-admin-user-list"}
            path={"/admin/user/list"}
            component={UsersList}
            roles={["Administrator"]}
        />

        <ProtectedRoute
            key={"route-admin-user-edit"}
            path={"/admin/user/edit/:id?"}
            component={EditUser}
            roles={["Administrator"]}
        />

        <ProtectedRoute
            key={"route-admin-order-list"}
            path={"/admin/order/list"}
            component={ConnectedOrdersList}
            roles={["Administrator"]}
        />

        <ProtectedRoute
            key={"route-admin-theme-list"}
            path={"/admin/theme/list"}
            component={ThemesList}
            roles={["Administrator"]}
        />
    </React.Fragment>
);

export default Admin;
